// extracted by mini-css-extract-plugin
export const videoWrapper = "video-module--videoWrapper--QLcBJ";